export default "__VITE_ASSET__DeZQXUZf__"